import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Borradores de facturas
    invoiceDrafts: {
      tableData: [],
      totalInvoiceDrafts: 0
    },
    queryInvoiceDrafts: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersInvoiceDrafts: [],

    // Datos Select Filtros
    optionsFilterInvoiceDraftBuyer: [],
    optionsFilterInvoiceDraftSeller: [],
    optionsFilterInvoiceDraftPartyCentres: []
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Borradores
    isShowIdBorrador: true,
    isShowServicioBorrador: false,
    isShowCompradorBorrador: true,
    isShowCentroCompradorBorrador: false,
    isShowCentroEntregaBorrador: false,
    isShowCentroFacturadoBorrador: false,
    isShowVendedorBorrador: true,
    isShowFechaEmisionBorrador: true,
    isShowNumeroFacturaBorrador: true,
    isShowFechaOperacionBorrador: true,
    isShowFechaRegistroBorrador: true,
    isShowTotalPagarBorrador: true,
    isShowTotalEjecutableBorrador: true,
    isShowDivisaBorrador: true
  }
  return local
}
function setByUserLocalDraft () {
  const local = {
    // Columnas Tabla Borradores
    isShowIdBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowIdBorrador,
    isShowServicioBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowServicioBorrador,
    isShowCompradorBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowCompradorBorrador,
    isShowCentroCompradorBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowCentroCompradorBorrador,
    isShowCentroEntregaBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowCentroEntregaBorrador,
    isShowCentroFacturadoBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowCentroFacturadoBorrador,
    isShowVendedorBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowVendedorBorrador,
    isShowFechaEmisionBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowFechaEmisionBorrador,
    isShowNumeroFacturaBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowNumeroFacturaBorrador,
    isShowFechaOperacionBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowFechaOperacionBorrador,
    isShowFechaRegistroBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowFechaRegistroBorrador,
    isShowTotalPagarBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowTotalPagarBorrador,
    isShowTotalEjecutableBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowTotalEjecutableBorrador,
    isShowDivisaBorrador: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).borradores.isShowDivisaBorrador
  }
  return local
}

// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Borradores
    isShowIdBorrador: true,
    isShowServicioBorrador: false,
    isShowCompradorBorrador: true,
    isShowCentroCompradorBorrador: false,
    isShowCentroEntregaBorrador: false,
    isShowCentroFacturadoBorrador: false,
    isShowVendedorBorrador: true,
    isShowFechaEmisionBorrador: true,
    isShowNumeroFacturaBorrador: true,
    isShowFechaOperacionBorrador: true,
    isShowFechaRegistroBorrador: true,
    isShowTotalPagarBorrador: true,
    isShowTotalEjecutableBorrador: true,
    isShowDivisaBorrador: true
  },
  session: initSession()
}

// getters
const getters = {
  // Datos Tablas Borradores
  invoiceDrafts: state => {
    return state.session.invoiceDrafts
  },
  queryInvoiceDrafts: state => {
    return state.session.queryInvoiceDrafts
  },
  listSelectedFiltersInvoiceDrafts: state => {
    return state.session.listSelectedFiltersInvoiceDrafts
  },

  // Datos Select Filtros
  optionsFilterInvoiceDraftBuyer: state => {
    return state.session.optionsFilterInvoiceDraftBuyer
  },
  optionsFilterInvoiceDraftSeller: state => {
    return state.session.optionsFilterInvoiceDraftSeller
  },
  optionsFilterInvoiceDraftPartyCentres: state => {
    return state.session.optionsFilterInvoiceDraftPartyCentres
  },

  // Columnas Tabla Borradores
  isShowIdBorrador: state => {
    return state.local.isShowIdBorrador
  },
  isShowServicioBorrador: state => {
    return state.local.isShowServicioBorrador
  },
  isShowCompradorBorrador: state => {
    return state.local.isShowCompradorBorrador
  },
  isShowCentroCompradorBorrador: state => {
    return state.local.isShowCentroCompradorBorrador
  },
  isShowCentroEntregaBorrador: state => {
    return state.local.isShowCentroEntregaBorrador
  },
  isShowCentroFacturadoBorrador: state => {
    return state.local.isShowCentroFacturadoBorrador
  },      
  isShowVendedorBorrador: state => {
    return state.local.isShowVendedorBorrador
  },
  isShowFechaEmisionBorrador: state => {
    return state.local.isShowFechaEmisionBorrador
  },
  isShowNumeroFacturaBorrador: state => {
    return state.local.isShowNumeroFacturaBorrador
  },
  isShowFechaOperacionBorrador: state => {
    return state.local.isShowFechaOperacionBorrador
  },
  isShowFechaRegistroBorrador: state => {
    return state.local.isShowFechaRegistroBorrador
  },
  isShowTotalPagarBorrador: state => {
    return state.local.isShowTotalPagarBorrador
  },
  isShowTotalEjecutableBorrador: state => {
    return state.local.isShowTotalEjecutableBorrador
  },
  isShowDivisaBorrador: state => {
    return state.local.isShowDivisaBorrador
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameDraft ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalDraft()
    }
  },
  isNewVersionBorradoresLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.borradores)
  },
  /* BORRADORES */
  /**
   * Servicio para traer los borradores.
   * Se utiliza también para ordenar la tabla, la paginación,
   * el tamaño de la tabla y los filtros.
   */
  async getInvoiceDrafts ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft',
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('INVOICE_DRAFTS_STATE', {
        tableData: response.data.content,
        totalInvoiceDrafts: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los detalles de un borrador.
   */
  async getDraftDetail ({
    commit, rootState
  }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/draft/' + draftId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para copiar un borrador
   */
  async copyDraft ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + data.draftId + '/copy',
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar un borrador
   * @param {*} data
   */
  async deleteDraft ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + data.draftId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los detalles de un borrador.
   */
  async getDraftAttachments ({
    commit, rootState
  }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + draftId + '/attachment'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar adjunto de un borrador
   * @param {*} data
   */
  async deleteAttachment ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + data.draftId + '/attachment/' + data.attachmentId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar adjunto de un borrador
   * @param {*} data
   */
  async downloadDraftAttachment ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + data.draftId + '/attachment/' + data.attachmentId,
        responseType: 'blob'
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      let filename = 'adjuntos.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para añadir adjuntos a un borrador de factura
   * @param {*} params
   */
  async addDraftAttachment ({
    commit, rootState
  }, data) {
    const formData = new FormData()
    formData.append('attachment', data.attachment.raw)
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + data.draftId + '/attachment',
        data: formData
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para Exportar Todos los borradores a CSV
   */
  async downloadAllCSVInvoiceDraft ({
    commit, rootState
  }, data) {
    try {
      data.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/csv',
        params: data,
        headers: { 'Accept-Language': data.activeLang },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'borradores.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos Tabla Borradores
  queryInvoiceDraftsState: ({
    commit
  }, payload) => {
    commit('QUERY_INVOICE_DRAFTS_STATE', payload)
  },
  listSelectedFiltersInvoiceDraftsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_INVOICE_DRAFTS_STATE', payload)
  },
  optionsFilterInvoiceDraftBuyerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_DRAFT_BUYER_STATE', payload)
  },
  optionsFilterInvoiceDraftSellerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_DRAFT_SELLER_STATE', payload)
  },
  optionsFilterInvoiceDraftPartyCentresState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_DRAFT_PARTY_CENTRES', payload)
  },

  // Tabla Borradores
  isShowIdBorrador: ({
    commit
  }, payload) => {
    commit('IS_SHOW_ID_BORRADOR', payload)
  },
  isShowServicioBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERVICIO_BORRADOR', payload)
  },
  isShowCompradorBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COMPRADOR_BORRADOR', payload)
  },   
  isShowCentroCompradorBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTROCOMPRADOR_BORRADOR', payload)
  },
  isShowCentroEntregaBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTROENTREGA_BORRADOR', payload)
  },
  isShowCentroFacturadoBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CENTROFACTURADO_BORRADOR', payload)
  },     
  isShowVendedorBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_VENDEDOR_BORRADOR', payload)
  },
  isShowFechaEmisionBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_EMISION_BORRADOR', payload)
  },
  isShowNumeroFacturaBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_NUMERO_FACTURA_BORRADOR', payload)
  },
  isShowFechaOperacionBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_OPERACION_BORRADOR', payload)
  },
  isShowFechaRegistroBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_FECHA_REGISTRO_BORRADOR', payload)
  },
  isShowTotalPagarBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TOTAL_PAGAR_BORRADOR', payload)
  },
  isShowTotalEjecutableBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_TOTAL_EJECUTABLE_BORRADOR', payload)
  },
  isShowDivisaBorradorAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DIVISA_BORRADOR', payload)
  }
}

// mutations
const mutations = {
  resetSessionBorradores (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  draftDatesSuperAdmin (state) {
    state.session.queryInvoiceDrafts.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Borradores
  'INVOICE_DRAFTS_STATE' (state, payload) {
    state.session.invoiceDrafts = payload
  },
  'QUERY_INVOICE_DRAFTS_STATE' (state, payload) {
    state.session.queryInvoiceDrafts = payload
  },
  'LIST_SELECTED_FILTERS_INVOICE_DRAFTS_STATE' (state, payload) {
    state.session.listSelectedFiltersInvoiceDrafts = payload
  },
  'OPTIONS_FILTER_INVOICE_DRAFT_BUYER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceDraftBuyer = payload
  },
  'OPTIONS_FILTER_INVOICE_DRAFT_SELLER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceDraftSeller = payload
  },
  'OPTIONS_FILTER_INVOICE_DRAFT_PARTY_CENTRES' (state, payload) {
    state.session.optionsFilterInvoiceDraftPartyCentres = payload
  },

  // Columnas Tabla Borradores
  'IS_SHOW_ID_BORRADOR' (state, payload) {
    state.local.isShowIdBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowIdBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICIO_BORRADOR' (state, payload) {
    state.local.isShowServicioBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowServicioBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COMPRADOR_BORRADOR' (state, payload) {
    state.local.isShowCompradorBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowCompradorBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTROCOMPRADOR_BORRADOR' (state, payload) {
    state.local.isShowCentroCompradorBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowCentroCompradorBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTROENTREGA_BORRADOR' (state, payload) {
    state.local.isShowCentroEntregaBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowCentroEntregaBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CENTROFACTURADO_BORRADOR' (state, payload) {
    state.local.isShowCentroFacturadoBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowCentroFacturadoBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },      
  'IS_SHOW_VENDEDOR_BORRADOR' (state, payload) {
    state.local.isShowVendedorBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowVendedorBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_EMISION_BORRADOR' (state, payload) {
    state.local.isShowFechaEmisionBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowFechaEmisionBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUMERO_FACTURA_BORRADOR' (state, payload) {
    state.local.isShowNumeroFacturaBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowNumeroFacturaBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_OPERACION_BORRADOR' (state, payload) {
    state.local.isShowFechaOperacionBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowFechaOperacionBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FECHA_REGISTRO_BORRADOR' (state, payload) {
    state.local.isShowFechaRegistroBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowFechaRegistroBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TOTAL_PAGAR_BORRADOR' (state, payload) {
    state.local.isShowTotalPagarBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowTotalPagarBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TOTAL_EJECUTABLE_BORRADOR' (state, payload) {
    state.local.isShowTotalEjecutableBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowTotalEjecutableBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DIVISA_BORRADOR' (state, payload) {
    state.local.isShowDivisaBorrador = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.borradores.isShowTotalEjecutableBorrador = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
